/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatedPilotDetails } from '../../models/created-pilot-details';

export interface GetPilot$Params {
  pilotId: number;
}

export function getPilot(http: HttpClient, rootUrl: string, params: GetPilot$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatedPilotDetails>> {
  const rb = new RequestBuilder(rootUrl, getPilot.PATH, 'get');
  if (params) {
    rb.path('pilotId', params.pilotId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatedPilotDetails>;
    })
  );
}

getPilot.PATH = '/pilots/{pilotId}';
